import React, { useEffect } from "react";
import { Grid, CircularProgress } from "@material-ui/core";
import "./styles/style.css";

import TablePaquetes from "../components/Tables/TablePaquetes/TablePaquetes";
// import TableCancelaciones from "../../components/Tables/TableCancelaciones/TableCancelaciones";
// import TableRecolecciones from "../../components/Tables/TableRecolecciones/TableRecolecciones";
// import useStyles from "./styles/stylesPaquetes";
import usePostPaquetes from "../hooks/paquetes/usePostPaquetes";
import useGetPaquetes from "../hooks/paquetes/useGetPaquetes";
import usePatchPaquetes from "../hooks/paquetes/usePatchPaquetes";
import useDeletePaquetes from "../hooks/paquetes/useDeletePaquetes";

const Paquetes = () => {
  const [{ data: update }, doPost] = usePostPaquetes();
  const [
    { data: paquetes, isLoading: isPaquetesLoading },
    doGet
  ] = useGetPaquetes("");
  const [{ data: patch }, doPatch] = usePatchPaquetes();
  const [{ data: deleted }, doDelete] = useDeletePaquetes();

  useEffect(() => {
    doGet(Math.random());
    // console.log(paquetes);
  }, [update, patch, deleted,doGet]);

  return isPaquetesLoading ? (
    <CircularProgress />
  ) : (
    <Grid container spacing={2}>
      <TablePaquetes
        data={paquetes}
        onAdd={doPost}
        onUpdate={doPatch}
        onDelete={doDelete}
      />
    </Grid>
  );
};

export default Paquetes;
